module.exports = "mutation DeleteVoucher ($id: String!) {\n  status: deleteVoucher(id: $id)\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/queries/DeleteVoucher.graphql
// module id = 2004
// module chunks = 1611